/**
 * Toast Provider Component
 * Configures react-hot-toast with fully squared styling
 */

import React from 'react';
import { Toaster } from 'react-hot-toast';

export const ToastProvider: React.FC = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        // Error toast styling - professional and compact
        error: {
          duration: 5000,
          icon: '',
          style: {
            borderRadius: '0',
            background: '#fef2f2',
            color: '#991b1b',
            border: '1px solid #fecaca',
            borderLeft: '3px solid #dc2626',
            padding: '10px 14px',
            fontSize: '13px',
            fontWeight: '400',
            maxWidth: '420px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          },
        },
      }}
    />
  );
};

/**
 * Toast utility functions for easy use throughout the app
 */
export const showToast = {
  error: (message: string) => {
    const { toast } = require('react-hot-toast');
    toast.error(message);
  },

  dismiss: (toastId?: string) => {
    const { toast } = require('react-hot-toast');
    toast.dismiss(toastId);
  },
};
